var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.6541C9.03757 11.6541 11.5 9.19162 11.5 6.15405C11.5 3.11649 9.03757 0.654053 6 0.654053C2.96243 0.654053 0.5 3.11649 0.5 6.15405C0.5 9.19162 2.96243 11.6541 6 11.6541Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.84454 3.09155C5.60801 3.09155 5.41626 3.2833 5.41626 3.51983V6.60122C5.41626 6.77047 5.51593 6.92385 5.6706 6.99259L7.98164 8.01972C8.19779 8.11578 8.45088 8.01844 8.54695 7.8023C8.64301 7.58615 8.54567 7.33306 8.32952 7.23699L6.27281 6.3229V3.51983C6.27281 3.2833 6.08107 3.09155 5.84454 3.09155Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTimer);
export default __webpack_public_path__ + "static/media/ic_timer.9b893a680b4c446d4a287ee82c816f58.svg";
export { ForwardRef as ReactComponent };